import { LicenseStatus } from '@/api/services/user';

export const showDigaPatientWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'diga' && licenseStatus.daysLeft <= 30) {
    return true;
  }

  return false;
};

export const showSelfPayerWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'selfpay' && licenseStatus.daysLeft <= 14) {
    return true;
  }

  return false;
};

export const showTrialWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'trial' && licenseStatus.daysLeft <= 7) {
    return true;
  }

  return false;
};

export const showExpiredTrialWarning = (licenseStatus: LicenseStatus) => {
  if (licenseStatus.type === 'trial' && licenseStatus.daysLeft < 1) {
    return true;
  }

  return false;
};

export const showWarningCheck = (licenseState: LicenseStatus) => {
  switch (licenseState.type) {
    case 'diga':
      return showDigaPatientWarning(licenseState);
    case 'selfpay':
      return showSelfPayerWarning(licenseState);
    case 'trial':
      return showTrialWarning(licenseState);
    default:
      return false;
  }
};

export const showLicenseWarning = (licenseState: LicenseStatus | null) => {
  if (!licenseState) {
    return false;
  }

  return showDigaPatientWarning(licenseState) && licenseState.daysLeft >= 0;
};
